module.exports = __webpack_public_path__ + "img/addclerk.7c266e26.png";